import type { MessageDescriptor } from 'react-intl';

interface InterruptedNoticeCopy {
  message: MessageDescriptor;
  action: MessageDescriptor;
  /** Sent instead of the original prompt, so work the turn already did is not redone. */
  followUpPrompt?: MessageDescriptor;
}

const RETRY: MessageDescriptor = { id: 'chat.interrupted.retry', defaultMessage: 'Try again' };

const GENERIC: InterruptedNoticeCopy = {
  message: {
    id: 'chat.interrupted.message',
    defaultMessage: 'Sorry, something interrupted this response. Click Try again to resend your message.',
  },
  action: RETRY,
};

const CUT_SHORT: InterruptedNoticeCopy = {
  message: { id: 'chat.interrupted.cutShort', defaultMessage: 'This response was cut short before it finished.' },
  action: RETRY,
};

const BY_REASON: Record<string, InterruptedNoticeCopy> = {
  cancelled: {
    message: { id: 'chat.interrupted.cancelled', defaultMessage: 'You stopped this response.' },
    action: RETRY,
  },
  no_reply: {
    message: { id: 'chat.interrupted.noReply', defaultMessage: 'The assistant finished without a written reply.' },
    action: { id: 'chat.interrupted.askForSummary', defaultMessage: 'Ask for a summary' },
    followUpPrompt: {
      id: 'chat.interrupted.summaryPrompt',
      defaultMessage: 'Please summarise what you did and the result.',
    },
  },
  credits_exhausted: {
    message: {
      id: 'chat.interrupted.creditsExhausted',
      defaultMessage: 'You ran out of credits before this response finished.',
    },
    action: RETRY,
  },
  limit: CUT_SHORT,
  tool_failures: CUT_SHORT,
};

export const interruptedNoticeCopy = (reason?: string): InterruptedNoticeCopy =>
  (reason && BY_REASON[reason]) || GENERIC;
